const md5 = require('md5');

const scopes = [
    "MERCHANT_PROFILE_READ",
    "ITEMS_READ",
    "ITEMS_WRITE",
    "ORDERS_READ",
    "ORDERS_WRITE",
    "PAYMENTS_READ",
    "CUSTOMERS_READ",
    "CUSTOMERS_WRITE",
    "GIFTCARDS_READ",
    "GIFTCARDS_WRITE",
    "INVENTORY_READ",
    "INVENTORY_WRITE",
    "INVOICES_READ",
    "INVOICES_WRITE"
];

//const squareBaseUri = "https://connect.squareupsandbox.com";
//const squareApplicationId = "sandbox-sq0idb-Y9ciCD54B_2USsfhFFYxFQ";

const squareBaseUri = "https://connect.squareup.com";
const squareApplicationId = "sq0idp-oaEblv6gq47i5XqiSTRj4Q";

export default function LoginApp() {
    const squareLoginUrl = `${squareBaseUri}/oauth2/authorize?client_id=${squareApplicationId}&response_type=code&`
        + `scope=${scopes.join('+')}&state=` + md5(Date.now());
    window.location.href = squareLoginUrl;
    return <h3>Redirecting to Square...</h3>
}